import { render, staticRenderFns } from "./ProjectCalendar.vue?vue&type=template&id=0a3bb518&"
import script from "./ProjectCalendar.vue?vue&type=script&lang=ts&"
export * from "./ProjectCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports